var _filter, _filter2, _filter3, _filter4, _filter5, _radialGradient, _radialGradient2, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g4, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g5, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 105,
    viewBox: "0 0 98 105",
    width: 98,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 103.621,
    width: 97.8224,
    x: 0.088806,
    y: 0.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_9219_4105",
    stdDeviation: 2
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 32.874,
    width: 34.2213,
    x: 16.5663,
    y: 49.2637
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_4105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_4105",
    mode: "normal",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 28.0371,
    width: 31.5329,
    x: 45.8786,
    y: 60.9873
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_4105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_4105",
    mode: "normal",
    result: "shape"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "d",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 29.1172,
    width: 33.0782,
    x: 30.7602,
    y: 55.9316
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_4105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_4105",
    mode: "normal",
    result: "shape"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "e",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 61.4629,
    width: 59.8881,
    x: 19.5568,
    y: 27.1553
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_4105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_4105",
    mode: "normal",
    result: "shape"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(4.11411522 36.15850057 -34.85580573 3.96589456 50.8004 51.4939)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ffc85c",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#ffc75b",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc759",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 35.4864 -49.8277 0 48.9999 52.5)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc85c",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc759",
    stopOpacity: 0
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#ffbf1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc536"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 63.3509,
    x2: 68.6019,
    xlinkHref: "#h",
    y1: 36.9893,
    y2: 54.8639
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 60.773,
    x2: 57.1417,
    xlinkHref: "#h",
    y1: 21.2346,
    y2: 33.5983
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 49.4697,
    x2: 46.3422,
    xlinkHref: "#h",
    y1: 32.2213,
    y2: 61.2392
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m46.0617 12.853 4.6268-.3491 4.6286.2658 4.5573.8765 4.4143 1.4734 4.2015 2.0471 3.9226 2.5884 3.5817 3.0889 3.1843 3.5408 2.7369 3.9367 2.2461 4.2707 1.72 4.5372 1.1668 4.7322.5951 4.8525.014 4.8965-.5672 4.863-1.1395 4.7529-1.6939 4.5679-2.2215 4.3109-2.7141 3.9858-3.1639 3.5979-3.5638 3.1532-3.9074 2.6589-4.1896 2.1225-4.4056 1.5528-4.552.9584-4.6268.3491-4.6286-.2658-4.5574-.8765-4.4142-1.4734-4.2015-2.047-3.9226-2.5884-3.5817-3.089-3.1844-3.5408-2.7368-3.9367-2.2461-4.2707-1.72-4.5372-1.1668-4.7322-.5951-4.8525-.014-4.8964.5672-4.8631 1.1395-4.7529 1.6939-4.5679 2.2215-4.3109 2.7141-3.9858 3.1639-3.5979 3.5637-3.1532 3.9075-2.6588 4.1896-2.1226 4.4055-1.5527z",
    fill: "url(#f)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49 4.5.9917 22.8858c.0982 2.265 3.294 2.6449 3.9203.466l6.279-21.84379-4.4038 22.57669c-.433 2.2199 2.5732 3.3398 3.6981 1.3777l11.1936-19.5251-9.6129 20.8811c-.9417 2.0456 1.6912 3.8456 3.2555 2.2256l15.4831-16.0345-14.3054 17.8323c-1.4015 1.7471.6889 4.1251 2.6013 2.9591l18.8943-11.5206-18.1359 13.5688c-1.7841 1.3348-.378 4.1471 1.7603 3.5208l21.1783-6.2027-20.7908 8.3562c-2.0601.828-1.4385 3.8949.7814 3.8554l22.1231-.3927-22.0493 2.5742c-2.2036.2573-2.412 3.3763-.2623 3.9245l21.6033 5.5095-21.8286-3.336c-2.198-.3359-3.2212 2.6279-1.284 3.7194l19.6269 11.0597-20.1918-8.9449c-2.0423-.9047-3.806 1.7108-2.2017 3.265l16.3494 15.8389-17.3144-13.8938c-1.7518-1.4056-4.1332.6988-2.9538 2.6102l12.0454 19.52-13.4322-17.9183c-1.354-1.8061-4.1959-.3361-3.5041 1.8126l7.0516 21.9022-8.7988-20.8383c-.8811-2.0866-4.0056-1.3318-3.8369.9269l1.7101 22.9041-3.666-22.5302c-.3642-2.2384-3.5838-2.2384-3.948 0l-3.666 22.5302 1.7101-22.9041c.1687-2.2587-2.9558-3.0135-3.8369-.9269l-8.7988 20.8383 7.0516-21.9022c.6918-2.1487-2.1501-3.6187-3.5041-1.8126l-13.4322 17.9183 12.0454-19.52c1.1794-1.9114-1.202-4.0158-2.9538-2.6102l-17.3144 13.8938 16.3494-15.8389c1.6043-1.5542-.1594-4.1697-2.2017-3.265l-20.19182 8.9449 19.62692-11.0597c1.9372-1.0915.914-4.0553-1.284-3.7194l-21.82863 3.336 21.60343-5.5095c2.1497-.5482 1.9412-3.6672-.2624-3.9245l-22.0493-2.5742 22.1231.3927c2.2199.0395 2.8415-3.0274.7814-3.8554l-20.79084-8.3562 21.17834 6.2027c2.1383.6263 3.5443-2.186 1.7603-3.5208l-18.1359-13.5688 18.8943 11.5206c1.9124 1.166 4.0028-1.212 2.6013-2.9591l-14.3054-17.8323 15.4831 16.0345c1.5643 1.62 4.1972-.18 3.2555-2.2256l-9.6129-20.8811 11.1936 19.5251c1.1249 1.9621 4.1311.8422 3.6981-1.3777l-4.4038-22.57669 6.279 21.84379c.6263 2.1789 3.8221 1.799 3.9203-.466z",
    fill: "url(#g)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.8729 67.8882c1.2423 2.6818 6.2131 2.6131 11.1027-.1535 4.8896-2.7665 7.8464-7.1833 6.6041-9.8651-.1288-.2781-.9581-2.0605-1.0894-2.3208-.5619-1.1134-3.0694-3.5118-10.7682.8443-7.8108 4.4194-7.2424 8.392-6.9163 9.1617.1157.2729.9398 2.0585 1.0671 2.3334z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.7677 65.5026c-1.2422-2.6818 1.7146-7.0986 6.6042-9.8652 4.8896-2.7665 9.8604-2.8352 11.1026-.1534s-1.7145 7.0986-6.6041 9.8651c-4.8896 2.7666-9.8605 2.8353-11.1027.1535z",
    fill: "#ffc22a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.9583 54.8652c.0027-.1-.1438-.1331-.3272-.0699-1.0918.3761-2.1716.8535-3.1883 1.4101-1.1196.6129-2.1406 1.3098-3.0048 2.051-.8643.7411-1.5547 1.512-2.032 2.2685-.4334.6869-.6832 1.3499-.7388 1.9577-.0093.1021.1378.1346.3212.075.1834-.0595.3336-.1887.3434-.291.0539-.5601.2852-1.1703.684-1.8025.4427-.7018 1.0832-1.4168 1.8849-2.1043.8016-.6875 1.7487-1.3339 2.7873-1.9025.9355-.5122 1.9288-.9521 2.9334-1.2997.1833-.0634.3342-.1924.3369-.2924z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.4167 65.5401c.0503.0828.2385.0792.418-.0112 1.984-.9993 3.7039-2.2621 4.8902-3.5904.1073-.1201.0607-.2205-.0978-.2239s-.3688.0915-.4765.2116c-1.0952 1.2211-2.676 2.3817-4.4986 3.3028-.1793.0906-.2857.2283-.2353.3111z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.8393 62.5859c-3.1518 2.7566-7.5694 4.0759-9.8668 2.9467-2.2974-1.1291-1.6048-4.279 1.547-7.0356 3.1518-2.7565 7.5694-4.0758 9.8668-2.9467s1.6048 4.279-1.547 7.0356z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.5195 58.497c3.1518-2.7565 7.5694-4.0758 9.8668-2.9467-3.595 1.2289-10.6128 7.0626-11.4138 9.9823-2.2974-1.1291-1.6048-4.279 1.547-7.0356z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6393 62.99c.3718-1.1836 1.2936-2.5072 2.7174-3.7524 3.1508-2.7556 7.5701-4.0755 9.8668-2.9467 1.0377.51 1.4661 1.4304 1.3332 2.5426.4493-1.4368.0907-2.6634-1.1704-3.2832-2.2967-1.1288-6.716.1911-9.8668 2.9467-1.7271 1.5105-2.7165 3.1415-2.8802 4.493z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.4195 57.8319c.1039-.2359-.4298-.799-.7031-.6205l-2.9326 2.5712c-.2302.1503-.4652.1165-.4483-.0645l.2242-2.3989c.0272-.291-.5687-.7772-.7093-.4576l-2.8914 6.5667c-.1039.2359.2051.9456.4784.7672l3.2094-2.0954c.2302-.1503.4653-.1164.4483.0645l-.2763 1.7764c-.0272.291.5686.7772.7093.4577z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.1428 57.3562c.1039-.2359-.153-.323-.4263-.1446l-3.2094 2.0954c-.2302.1503-.4652.1164-.4483-.0646l.2242-2.3988c.0272-.2911-.5165-.1547-.6572.1648l-2.8914 6.5668c-.1038.2359.153.3231.4263.1446l3.2094-2.0953c.2302-.1503.4653-.1165.4483.0645l-.2241 2.3988c-.0272.2911.5164.1548.6571-.1648z",
    fill: "#ffdd28"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.5902 70.3496c-.474 3.4945 3.3711 6.9712 8.5882 7.7656 5.2171.7943 9.8306-1.3946 10.3045-4.8891.0492-.3623.1926-1.443.2303-1.7897.1614-1.4838-.4848-5.6044-8.6993-6.8551-8.3339-1.2689-10.0104 3.0009-10.1697 3.9822-.0565.3479-.2055 1.428-.254 1.7861z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.8853 68.1742c.4739-3.4945 5.0874-5.6834 10.3045-4.8891 5.2171.7944 9.0622 4.2711 8.5883 7.7656-.474 3.4944-5.0874 5.6833-10.3045 4.889s-9.0622-4.2711-8.5883-7.7655z",
    fill: "#ffc32d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.4496 74.6548c-3.8803.4348-7.9663-1.4309-9.1263-4.1671-1.1601-2.7362 1.0452-5.3068 4.9255-5.7415 3.8803-.4348 7.9663 1.4309 9.1263 4.1671 1.1601 2.7362-1.0452 5.3068-4.9255 5.7415z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.2488 64.7462c3.8803-.4348 7.9663 1.4309 9.1263 4.1671-2.5025-.381-9.4954-1.4457-14.0518 1.5744-1.1601-2.7362 1.0452-5.3068 4.9255-5.7415z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.6535 67.0638c.9141-.8864 2.324-1.5169 4.0768-1.7133 3.8791-.4346 7.9667 1.4319 9.1264 4.1672.524 1.2359.3629 2.4367-.3303 3.4239 1.1082-1.0774 1.4855-2.5264.8487-4.0283-1.1596-2.7353-5.2472-4.6017-9.1263-4.1671-2.1263.2382-3.7514 1.1195-4.5953 2.3176z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.0156 64.2868c.0512-.1013-.0502-.2238-.2285-.2693-1.0619-.2712-2.1638-.4308-3.2539-.4709-1.2005-.044-2.3631.0579-3.4214.2999s-1.9917.6195-2.7467 1.1108c-.6856.4461-1.2121.9781-1.5553 1.5706-.0576.0995.0446.2218.2212.271.1765.0493.3606.0068.4188-.0925.3185-.5444.8041-1.0334 1.435-1.4439.7004-.4557 1.5662-.8058 2.5479-1.0304.9817-.2245 2.0601-.319 3.1736-.2781 1.0032.0368 2.0172.1829 2.9949.4308.1785.0452.3631.0034.4144-.098z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.1339 75.1588c-.0002.1156.1528.2254.3413.2406 2.0847.1675 4.0867-.0956 5.6921-.7481.1453-.059.1572-.1905.0315-.2896-.1256-.0991-.3412-.1283-.4867-.0695-1.4797.5971-3.3197.8389-5.2363.6882-.1885-.0149-.3417.0627-.3419.1784z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.9989 70.1089c.2294-.1173.1601-.953-.1671-1.0028l-3.9207-.0025c-.2756-.042-.4399-.2366-.3135-.3712l1.6759-1.784c.2034-.2165.037-1.0341-.2737-.8753l-6.9226 3.182c-.2294.1173.1087.9939.4358 1.0437l3.8418.5849c.2756.042.4399.2366.3135.3712l-1.8657 1.1607c-.2034.2165.5006 1.1159.8113.9571z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.0781 69.5266c.2294-.1173.0811-.3706-.246-.4204l-3.8418-.5849c-.2756-.042-.4399-.2365-.3135-.3711l1.6759-1.7841c.2033-.2165-.3108-.4926-.6215-.3338l-6.385 3.2638c-.2294.1173-.0811.3706.246.4204l3.8418.5849c.2756.042.4399.2366.3135.3712l-1.6759 1.784c-.2034.2165.3108.4926.6215.3338z",
    fill: "#ffdd28"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.7824 46.7526c-.8109 2.8484 1.9792 6.2592 6.2317 7.6182 4.2526 1.359 8.3573.1516 9.1681-2.6968.0841-.2953.3322-1.1766.4049-1.4605.3112-1.2148.2632-4.7346-6.4326-6.8744-6.7931-2.171-8.6983 1.1628-8.9478 1.9592-.0885.2823-.3412 1.1624-.4243 1.4543z",
    fill: "#f19018"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.2874 44.9797c.8109-2.8484 4.9156-4.0558 9.1681-2.6968 4.2525 1.3591 7.0426 4.7698 6.2318 7.6182-.8109 2.8484-4.9156 4.0558-9.1681 2.6968-4.2526-1.3591-7.0426-4.7698-6.2318-7.6182z",
    fill: "#ffc32d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m23.1527 51.9302c-3.285-.1563-6.4676-2.2569-7.1084-4.6918-.6409-2.4349 1.5026-4.2821 4.7876-4.1259 3.285.1563 6.4675 2.2569 7.1084 4.6918.6409 2.435-1.5026 4.2822-4.7876 4.1259z",
    fill: "#f39e09"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m20.8319 43.1125c3.285.1563 6.4675 2.2569 7.1084 4.6918-2.0399-.6519-7.7399-2.4735-11.896-.5659-.6409-2.4349 1.5026-4.2821 4.7876-4.1259z",
    fill: "#ffaa16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m16.727 44.4296c.8672-.6164 2.117-.9533 3.6009-.8828 3.2839.1563 6.4678 2.2577 7.1084 4.6918.2895 1.0999.0124 2.0789-.6827 2.8089 1.0516-.7497 1.5385-1.9066 1.1867-3.2432-.6407-2.4341-3.8245-4.5355-7.1084-4.6918-1.8001-.0856-3.2591.4316-4.1049 1.3171z",
    fill: "#e88102",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m24.858 43.3632c.0548-.0776-.0152-.1932-.1584-.255-.8525-.3678-1.7516-.6481-2.6552-.8271-.995-.1971-1.9759-.2676-2.8865-.2073-.9107.0602-1.7333.25-2.4209.5584-.6244.2801-1.1263.6531-1.4829 1.1009-.0598.0753.0108.1908.152.2554.1413.0647.2998.0539.36-.0211.3302-.4111.793-.7536 1.3676-1.0114.6379-.2861 1.4009-.4622 2.2456-.518.8448-.0559 1.7546.0094 2.6776.1923.8315.1647 1.659.4219 2.4442.7592.1433.0615.3021.0513.3569-.0263z",
    fill: "#ffe77e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m21.1628 52.0369c-.0139.0963.1004.2083.2557.2461 1.7171.4182 3.4166.4665 4.832.1373.128-.0298.1536-.1377.0607-.2371s-.2691-.1525-.3973-.123c-1.304.2998-2.866.2555-4.445-.1263-.1553-.0375-.2922.0067-.3061.103z",
    fill: "#ffe77e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m25.8172 48.4807c.2051-.067.2469-.7726-.0198-.8578l-3.2666-.5261c-.2246-.0717-.3384-.2558-.217-.3511l1.6087-1.2626c.1953-.1532.154-.8567-.1238-.7659l-6.147 1.7263c-.2051.0671-.0277.8427.239.9279l3.1315 1.0008c.2246.0717.3383.2558.2169.3511l-1.6927.7178c-.1952.1532.2843.9968.5621.906z",
    fill: "#e88711"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m25.9524 48.0057c.2051-.0671.1118-.2979-.1549-.3831l-3.1315-1.0008c-.2246-.0718-.3384-.2559-.217-.3511l1.6087-1.2626c.1952-.1532-.2003-.4521-.4781-.3612l-5.7087 1.8663c-.2051.0671-.1117.2979.1549.3831l3.1316 1.0008c.2246.0718.3383.2559.2169.3511l-1.6087 1.2626c-.1952.1532.2003.4521.4781.3612z",
    fill: "#ffdd28"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m41.0542 39.831c-.5234 1.7551-3.5576 2.199-6.7772.9913-3.2195-1.2077-5.4052-3.6096-4.8818-5.3647.0543-.182.4044-1.3489.4617-1.5203.2454-.7332 1.5643-2.4392 6.6335-.5377 5.143 1.9292 5.1425 4.4049 5.0108 4.9057-.0467.1775-.3934 1.3458-.447 1.5257z",
    fill: "#f19018"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5198 38.2697c.5234-1.7552-1.6623-4.157-4.8818-5.3647s-6.2538-.7639-6.7772.9913c-.5233 1.7551 1.6623 4.1569 4.8819 5.3646 3.2195 1.2077 6.2537.7639 6.7771-.9912z",
    fill: "#ffc22a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m34.3861 32.7849c-.0103-.0607.076-.0951.1932-.0746.6979.1225 1.3973.3079 2.0651.5476.7354.264 1.4181.5888 2.0091.9559.5909.3671 1.0786.7692 1.4352 1.1834.3238.3762.5338.7556.6205 1.1205.0146.0613-.0722.0955-.1891.0771s-.2197-.0824-.2346-.1437c-.0816-.336-.2756-.6852-.5736-1.0313-.3307-.3843-.7831-.7573-1.3313-1.0978s-1.1815-.6418-1.8636-.8867c-.6146-.2206-1.2579-.3916-1.9002-.5052-.1172-.0207-.2204-.0846-.2307-.1452z",
    fill: "#ffe77e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m35.6448 39.236c-.0235.0553-.1385.0715-.2557.034-1.2956-.4149-2.4533-1.0162-3.2916-1.7095-.0758-.0627-.0561-.1284.0401-.146.0963-.0176.2326.0197.3087.0824.7735.6369 1.8375 1.1895 3.028 1.5726.1171.0376.194.1111.1705.1665z",
    fill: "#ffe77e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m33.3034 37.7664c2.16 1.3714 4.966 1.7435 6.2674.8312 1.3013-.9123.6052-2.7636-1.5548-4.135s-4.966-1.7435-6.2673-.8312c-1.3014.9123-.6053 2.7636 1.5547 4.135z",
    fill: "#f39e09"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m38.016 34.4626c-2.16-1.3714-4.966-1.7435-6.2673-.8312 2.297.3974 7.08 3.2657 7.8221 4.9662 1.3013-.9123.6052-2.7636-1.5548-4.135z",
    fill: "#ffaa16"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m40.1617 36.9183c-.3296-.6847-1.0063-1.401-1.982-2.0205-2.1593-1.3709-4.9664-1.7432-6.2674-.8311-.5878.4121-.7687 1.0146-.5909 1.6792-.3988-.8314-.2871-1.6137.4273-2.1145 1.3009-.912 4.108-.5397 6.2673.8312 1.1836.7514 1.9283 1.6484 2.1457 2.4557z",
    fill: "#e88102",
    fillOpacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m33.1449 34.8324c-.0838-.1336.1923-.5287.3743-.4467l2.0104 1.2799c.1533.0691.2935.0255.2675-.0831l-.3454-1.4395c-.0419-.1747.2788-.529.3923-.3481l2.333 3.718c.0838.1336-.0427.5961-.2248.5141l-2.1375-.963c-.1533-.069-.2935-.0254-.2675.0832l.323 1.0551c.0419.1747-.2788.5291-.3923.3481z",
    fill: "#e88711"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m33.2722 34.516c-.0838-.1335.0651-.2117.2471-.1297l2.1376.9629c.1533.0691.2935.0255.2675-.0831l-.3454-1.4395c-.0419-.1746.3012-.1447.4147.0362l2.333 3.7181c.0838.1335-.0651.2117-.2472.1297l-2.1375-.9629c-.1533-.0691-.2935-.0255-.2675.0831l.3453 1.4395c.0419.1746-.3011.1447-.4146-.0362z",
    fill: "#ffdd28"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.8798 68.9122c.5199 3.6391 5.4342 5.8686 10.9764 4.9798s9.6136-4.5594 9.0937-8.1986c-.0539-.3773-.2179-1.5017-.2789-1.8598-.2613-1.5324-2.1018-5.4353-10.8282-4.0358-8.8533 1.4199-9.3359 6.2201-9.2166 7.2505.0423.3652.2004 1.4909.2536 1.8639z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.5563 66.6461c-.5199-3.6391 3.5515-7.3098 9.0937-8.1986s10.4565 1.3408 10.9764 4.9799-3.5516 7.3097-9.0938 8.1986c-5.5422.8888-10.4564-1.3408-10.9763-4.9799z",
    fill: "#ffc32d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.1946 69.3765c-3.8279 1.6843-8.5253 1.1397-10.492-1.2163-1.9667-2.3561-.4579-5.6314 3.37-7.3157 3.8279-1.6842 8.5253-1.1396 10.492 1.2164 1.9667 2.3561.4579 5.6314-3.37 7.3156z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.0726 60.8445c3.8279-1.6842 8.5253-1.1396 10.492 1.2164-2.6585.4264-10.0872 1.6177-13.862 6.0993-1.9667-2.3561-.4579-5.6314 3.37-7.3157z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.0566 64.6377c.6768-1.1789 1.9321-2.2623 3.6612-3.0231 3.8267-1.6837 8.526-1.1389 10.492 1.2164.8884 1.0642 1.0689 2.3141.646 3.5224.8197-1.432.7883-2.9992-.2912-4.2925-1.9661-2.3553-6.6654-2.9001-10.492-1.2164-2.0976.923-3.5001 2.326-4.016 3.7932z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.7964 58.8496c.0232-.1177-.1153-.2072-.31-.1951-1.1594.0716-2.3277.2675-3.4496.5788-1.2355.343-2.3905.8193-3.3991 1.4018-1.0086.5826-1.851 1.2599-2.4792 1.9934-.5704.666-.954 1.3665-1.1336 2.0682-.0301.1179.109.207.303.1992s.3694-.1095.4001-.2273c.1682-.6458.5226-1.2902 1.0475-1.9031.5827-.6804 1.3641-1.3087 2.2997-1.849.9356-.5404 2.007-.9822 3.153-1.3003 1.0324-.2866 2.1072-.4676 3.1743-.5354.1948-.0123.3708-.1136.3939-.2312z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.9803 70.6251c.033.1154.2203.1757.4167.1301 2.1716-.5047 4.1354-1.4124 5.5835-2.5808.131-.1057.1054-.2408-.051-.2991-.1564-.0584-.3843-.018-.5158.0875-1.3358 1.0726-3.1408 1.9068-5.1363 2.3741-.1963.046-.3301.1728-.2971.2882z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.4281 64.5766c.2-.1909-.1104-1.0023-.4579-.9466l-3.9946 1.261c-.2927.047-.5159-.0942-.4257-.2692l1.1952-2.3201c.145-.2815-.259-1.0436-.5299-.785l-5.8531 5.3598c-.2.1909.1103 1.0023.4579.9466l4.0812-.6545c.2927-.047.5159.0942.4257.2693l-1.2818 1.7135c-.1451.2815.5446.9978.8155.7392z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.3413 63.9696c.2-.1909-.0236-.3958-.3712-.3401l-4.0812.6546c-.2927.0469-.5159-.0943-.4257-.2693l1.1952-2.32c.145-.2815-.458-.3914-.7289-.1328l-5.5675 5.314c-.2.1909.0237.3959.3712.3401l4.0812-.6545c.2928-.0469.516.0943.4258.2693l-1.1952 2.32c-.145.2815.4579.3913.7289.1328z",
    fill: "#ffdd28"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m56.3328 48.7258c1.185 5.0219 5.6387 8.067 9.9477 6.8015 4.3089-1.2655 6.0872-2.1929 4.0309-10.907-2.0115-8.5246-4.0133-8.5444-8.3222-7.2789-4.309 1.2655-6.8414 6.3625-5.6564 11.3844z",
    fill: "#f19018"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m67.6348 55.148c4.3016-1.2637 6.8296-6.353 5.6467-11.3674-1.183-5.0144-5.6291-8.0549-9.9306-6.7913-4.3015 1.2637-6.8296 6.353-5.6466 11.3674 1.183 5.0143 5.629 8.0549 9.9305 6.7913z",
    fill: "url(#i)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m60.1523 45.1336c-.3387 3.6903 1.8246 7.0844 4.832 7.5809 3.0074.4966 5.7199-2.0924 6.0587-5.7827.3387-3.6902-1.8246-7.0843-4.832-7.5809s-5.72 2.0925-6.0587 5.7827z",
    fill: "#f39e09"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m65.7961 39.9566c-3.018-.4984-4.3887 1.3712-4.9468 2.5129 1.8497.6044 6.812 4.1502 8.5902 8.1717 2.8407-5.0793-.6254-10.1863-3.6434-10.6846z",
    fill: "#ffaa16"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m68.6866 51.7139c.93-1.0353 1.5656-2.4762 1.7186-4.1431.3386-3.6891-1.8256-7.0845-4.832-7.5809-1.3584-.2243-2.6553.1792-3.7023 1.0309 1.1307-1.2556 2.6893-1.9122 4.3401-1.6396 3.0064.4964 5.1706 3.8918 4.832 7.5809-.1856 2.0221-1.0859 3.7156-2.3564 4.7518z",
    fill: "#e88102",
    fillOpacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m68.739 46.303c.2283-.1555.194-.5539-.0569-.6611l-2.9461-1.2591c-.2113-.0903-.2789-.4012-.129-.593l1.9872-2.5423c.2412-.3085-.7693-1.0694-1.0785-.8588l-5.6705 4.6219c-.2283.1555-.1908.9144.0601 1.0217l2.9429.8985c.2113.0903.2789.4012.129.593l-1.7957 2.8194c-.2411.3085.8295.8707 1.1388.66z",
    fill: "#e88711"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m69.2419 46.03c.2163-.1785.1506-.5734-.109-.6554l-3.0482-.9628c-.2186-.0691-.3108-.3732-.1759-.58l1.7884-2.7417c.217-.3327-.1465-.7684-.4393-.5266l-6.0189 4.9674c-.2162.1785-.1505.5734.1091.6554l3.0481.9628c.2187.0691.3109.3732.176.58l-1.7884 2.7417c-.217.3327.1464.7684.4393.5267z",
    fill: "#ffd83b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m61.9312 38.6052c-.0678-.1526-.0148-.3363.1208-.4042.8074-.4042 1.6758-.6405 2.5645-.6971.9788-.0622 1.9629.0948 2.8962.4622s1.7975.9379 2.5433 1.679c.6773.673 1.2448 1.4746 1.6765 2.3666.0725.1498.0189.3333-.1143.4067-.1333.0735-.2957.009-.3686-.1405-.3992-.8196-.9223-1.5563-1.5455-2.1756-.6918-.6875-1.4935-1.2167-2.3592-1.5575s-1.7786-.4865-2.6864-.4287c-.8179.052-1.6172.2682-2.3612.6377-.1357.0675-.2984.0039-.3661-.1486z",
    fill: "#ffe77e"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m66.9182 54.2544c.0278.1666-.0686.3248-.2161.3466-1.6309.2413-3.2985-.1377-4.7414-1.0777-.1305-.085-.1715-.2744-.0945-.4171.077-.1428.2428-.1847.3736-.1001 1.3287.86 2.8614 1.2084 4.3616.9913.1476-.0213.289.0905.3168.257z",
    fill: "#ffe77e"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m65.0599 29.1881c-.8198 3.4732-3.6855 5.6426-6.4005 4.8455-2.7151-.797-3.83-1.4046-2.4074-7.4313 1.3917-5.8958 2.6613-5.9433 5.3764-5.1463 2.715.7971 4.2514 4.2589 3.4315 7.7321z",
    fill: "#f19018"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m57.8093 33.7944c-2.7101-.796-4.2437-4.2529-3.4253-7.7212s3.6788-5.6346 6.389-4.8386c2.7101.7959 4.2437 4.2528 3.4253 7.7211s-3.6789 5.6347-6.389 4.8387z",
    fill: "url(#j)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m62.6796 26.773c.1668 2.5255-1.2446 4.893-3.1526 5.2878-1.9079.3948-3.5899-1.3325-3.7567-3.858-.1668-2.5256 1.2447-4.893 3.1527-5.2878 1.9079-.3949 3.5898 1.3324 3.7566 3.858z",
    fill: "#f39e09"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m59.1791 23.3237c1.9155-.3962 2.7586.8612 3.097 1.6341-1.1779.4478-4.3624 2.9687-5.5389 5.7585-1.7317-3.4319.5264-6.9965 2.4419-7.3926z",
    fill: "#ffaa16"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m57.1993 31.4388c-.5748-.6935-.9582-1.6705-1.0335-2.8113-.1668-2.5248 1.2453-4.8932 3.1526-5.2879.8619-.1783 1.6767.0751 2.3277.6406-.6987-.841-1.6758-1.2634-2.7231-1.0467-1.9074.3947-3.3194 2.7631-3.1527 5.2878.0914 1.384.6389 2.5295 1.429 3.2175z",
    fill: "#e88102",
    fillOpacity: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m62.0257 27.4954c.1442-.1296.1133-.3967-.0513-.4432l-1.933-.5461c-.1386-.0392-.1892-.2433-.0965-.3894l1.2292-1.9356c.1491-.2348-.5211-.6457-.7164-.4701l-3.5653 3.7347c-.1442.1297-.1133.3967.0514.4432l1.9329.5462c.1386.0391.1892.2433.0965.3893l-1.7127 1.95c-.1491.2349.5556.5045.751.3289z",
    fill: "#e88711"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m61.5437 27.3605c.1442-.1296.1132-.3966-.0514-.4431l-1.9328-.5462c-.1387-.0391-.1892-.2433-.0965-.3893l1.2291-1.9355c.1491-.2349-.0721-.5189-.2674-.3434l-4.0141 3.6079c-.1442.1296-.1133.3966.0513.4431l1.9329.5462c.1386.0392.1892.2433.0964.3893l-1.2291 1.9356c-.1491.2348.0721.5189.2675.3433z",
    fill: "#ffd83b"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m61.6544 22.3335c.045-.106.014-.2315-.0709-.2759-.5059-.2645-1.0528-.4126-1.6151-.4367-.6192-.0266-1.2448.0976-1.8412.3656s-1.1519.6745-1.6347 1.1963c-.4384.4738-.8091 1.0343-1.095 1.6546-.048.1041-.0167.2294.0667.2777s.1872.0013.2355-.1028c.2643-.5699.6059-1.085 1.0094-1.521.4478-.4841.9631-.8611 1.5163-1.1097s1.1336-.3639 1.7079-.3392c.5175.0222 1.0209.1576 1.487.3993.0851.0441.1891-.0023.2341-.1082z",
    fill: "#ffe77e"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m58.2713 33.1664c-.02.115.0388.2222.132.2347 1.0298.139 2.0914-.1492 3.0186-.8193.0838-.0606.1124-.1915.0656-.2883-.0468-.0969-.1512-.123-.2352-.0626-.8537.6132-1.8295.878-2.7768.7536-.0932-.0122-.1843.067-.2042.1819z",
    fill: "#ffe77e"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.3965 48.3537c-.61 8.0497-6.8249 13.9588-13.8815 13.1983-7.0566-.7604-10.0692-1.6973-9.0107-15.6653 1.0355-13.6642 4.1631-14.2456 11.2197-13.4851 7.0565.7604 12.2825 7.9025 11.6725 15.9521z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.2634 61.3385c-7.0479-.7596-12.2675-7.8935-11.6582-15.934.6092-8.0405 6.8166-13.9428 13.8645-13.1832s12.2675 7.8935 11.6582 15.934-6.8166 13.9428-13.8645 13.1832z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.6238 43.7937c1.4137 5.5191-1.2161 11.3124-5.8737 12.9397-4.6577 1.6273-9.5795-1.5276-10.9932-7.0468-1.4136-5.5191 1.2161-11.3124 5.8738-12.9397 4.6576-1.6273 9.5794 1.5277 10.9931 7.0468z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.4154 37.5546c4.6648-1.6302 7.2798.814 8.4348 2.3874-2.7883 1.4533-9.8126 8.2764-11.6782 14.9013-5.7049-6.8961-1.4215-15.6586 3.2434-17.2887z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.6264 56.2633c-1.7225-1.3063-3.0737-3.3155-3.7123-5.8085-1.4132-5.5174 1.2176-11.313 5.8737-12.9398 2.104-.735 4.259-.4966 6.1237.4965-2.0934-1.5837-4.7242-2.1315-7.2808-1.2382-4.6562 1.6267-7.287 7.4224-5.8738 12.9397.7747 3.0243 2.6062 5.3412 4.8695 6.5503z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.1924 45.7285c.3057-.3407.1155-.9221-.3155-.9649l-5.0621-.502c-.3631-.036-.5758-.4705-.4057-.8288l2.2543-4.7483c.2736-.5761-1.5752-1.2419-1.9892-.7804l-7.3332 9.6007c-.3057.3407-.1155.9221.3155.9648l5.0621.502c.3631.0361.5758.4706.4057.8288l-3.4567 4.9581c-.2736.5762 1.6018.9156 2.0159.4541z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.9265 45.6073c.3057-.3408.1156-.9221-.3155-.9649l-5.062-.502c-.363-.036-.5757-.4705-.4056-.8287l2.2542-4.7483c.2736-.5761-.3994-1.1253-.8135-.6638l-8.5087 9.4839c-.3056.3408-.1155.9221.3155.9649l5.062.502c.3631.036.5757.4705.4057.8287l-2.2543 4.7483c-.2735.5761.3995 1.1253.8135.6638z",
    fill: "#ffd83b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffe77e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.0523 34.3647c.0684-.2535-.0605-.5215-.2906-.5884-1.3701-.3982-2.7943-.5213-4.2056-.3621-1.5543.1753-3.0623.6895-4.4382 1.5133-1.3758.8237-2.5925 1.9409-3.5805 3.2877-.8971 1.2229-1.5897 2.6134-2.0462 4.1053-.0767.2505.0532.518.2809.5941.2278.0761.4671-.068.5444-.3183.4236-1.3714 1.0625-2.6499 1.8881-3.7753.9164-1.2493 2.045-2.2855 3.3212-3.0496 1.2762-.7642 2.6751-1.2411 4.1168-1.4038 1.2988-.1465 2.6094-.0352 3.871.3272.2302.0662.4702-.0767.5387-.3301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.2287 59.7017c-.0022.2642.1888.4811.4264.4739 2.6265-.0801 5.156-1.1258 7.192-2.973.1841-.1671.2013-.4702.0445-.6686-.1567-.1985-.4282-.2172-.6127-.0507-1.8763 1.6926-4.2012 2.6536-6.616 2.7348-.2375.008-.4321.2194-.4342.4836z"
  })))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m66.3793 51.0436c-2.2166 2.4989-.926 7.5994 2.8827 11.3922 3.8088 3.7928 8.6933 4.8417 10.9099 2.3427.2299-.2591.9128-1.0338 1.1252-1.2874.909-1.0852 2.5469-4.7617-3.4501-10.7336-6.0842-6.0587-9.6814-3.6699-10.3251-2.9841-.2282.2432-.9154 1.0141-1.1426 1.2702z",
    fill: "#f19018"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m67.7591 49.4874c2.2166-2.4989 7.1011-1.45 10.9099 2.3428 3.8087 3.7928 5.0993 8.8932 2.8827 11.3922-2.2166 2.4989-7.1012 1.45-10.9099-2.3428s-5.0994-8.8933-2.8827-11.3922z",
    fill: "#ffc32d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m73.7262 61.6581c-3.3707-2.0034-5.7014-5.9654-5.2058-8.8493s3.6299-3.5978 7.0006-1.5944c3.3707 2.0033 5.7014 5.9653 5.2058 8.8492-.4956 2.884-3.6299 3.5978-7.0006 1.5945z",
    fill: "#f39e09"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m75.521 51.2144c3.3707 2.0033 5.7014 5.9653 5.2058 8.8492-1.827-1.8193-6.9321-6.9031-12.2064-7.2548.4956-2.8839 3.6299-3.5978 7.0006-1.5944z",
    fill: "#ffaa16"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m70.5836 50.2791c1.2053-.153 2.6779.1982 4.2005 1.1031 3.3696 2.0027 5.7012 5.9663 5.2058 8.8493-.2239 1.3027-.9841 2.1624-2.0633 2.5297 1.4626-.1879 2.5281-1.1145 2.8002-2.6976.4954-2.883-1.8362-6.8465-5.2058-8.8492-1.8471-1.0978-3.6255-1.3793-4.9374-.9353z",
    fill: "#e88102",
    fillOpacity: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m79.622 53.7358c.0947-.0498.0767-.2088-.0438-.3531-.7178-.8593-1.5265-1.6539-2.3884-2.346-.9491-.7621-1.9442-1.385-2.9282-1.833-.9841-.4479-1.938-.7123-2.8072-.7779-.7893-.0595-1.4947.0458-2.0834.3103-.0989.0445-.0802.2038.0369.35.1172.1462.2886.2239.3878.1799.5435-.2411 1.1932-.3369 1.9196-.2821.8062.0609 1.691.3061 2.6039.7216.9128.4155 1.8358.9933 2.7162 1.7003.7932.6368 1.5378 1.3674 2.1997 2.1572.1208.1441.2922.2225.3869.1728z",
    fill: "#ffe77e"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m71.5854 60.6581c-.0607.0921.0055.2723.1503.3985 1.6005 1.3961 3.3599 2.3988 5.0024 2.8508.1486.0409.2272-.0567.1774-.2118-.0497-.1551-.2091-.3089-.3578-.3502-1.5115-.42-3.1286-1.3416-4.6018-2.6225-.1449-.126-.3097-.1569-.3705-.0648z",
    fill: "#ffe77e"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m77.7558 59.8517c.2473.0455.6295-.6627.3907-.9006l-3.1741-2.3764c-.2012-.2004-.2322-.455-.0592-.4857l2.293-.4074c.2782-.0495.5723-.8021.2374-.8636l-7.0793-1.4602c-.2473-.0454-.6295.6628-.3907.9006l2.8047 2.793c.2012.2003.2322.455.0592.4857l-1.9236-.0091c-.2782.0495-.3761.9975-.0411 1.059z",
    fill: "#e88711"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m78.125 59.4347c.2473.0455.2601-.2463.0212-.4841l-2.8047-2.793c-.2011-.2003-.2322-.4549-.0592-.4857l2.2931-.4074c.2782-.0494.0066-.581-.3283-.6425l-6.8831-1.2647c-.2473-.0455-.2601.2463-.0212.4841l2.8047 2.793c.2011.2003.2322.4549.0592.4857l-2.2931.4074c-.2782.0494-.0066.581.3283.6425z",
    fill: "#ffdd28"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.3263 29.7178.351 4.327 3.6019-2.4235-3.1642 2.9723 4.1404 1.305-4.2966-.6206 1.5612 4.0508-2.1937-3.7463-2.1936 3.7463 1.5612-4.0508-4.2966.6206 4.1404-1.305-3.1642-2.9723 3.6019 2.4235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.1339 60.626.2381 2.9362 2.4441-1.6445-2.1471 2.0169 2.8096.8855-2.9156-.4211 1.0594 2.7487-1.4885-2.5421-1.4886 2.5421 1.0594-2.7487-2.9156.4211 2.8096-.8855-2.1471-2.0169 2.4441 1.6445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.7979 49.4307.2382 2.9362 2.4441-1.6445-2.1471 2.0169 2.8096.8855-2.9156-.4211 1.0594 2.7487-1.4886-2.5421-1.4885 2.5421 1.0594-2.7487-2.9156.4211 2.8096-.8855-2.1471-2.0169 2.4441 1.6445z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins04);
export default __webpack_public_path__ + "static/media/coins-04.796e46d925c2d0196789d43c4f09f401.svg";
export { ForwardRef as ReactComponent };